module.exports = __webpack_public_path__ + "img/default_logo_football.e79802ab.png";